module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp2_8023.eb0de952.png";